var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-chart',{attrs:{"data":_vm.chartData,"height":_vm.chartHeight,"padding":_vm.chartPadding,"axis":false,"grid-size":_vm.size,"datetime-format":"HH:mm","base-zero":"","timeseries":"","compare-timeseries":""}})}
var staticRenderFns = []

export { render, staticRenderFns }